<a class="flex items-center gap-2" [routerLink]="link()">
  <ui-icon class="flex-shrink-0" icon="griddy-chevron-left" />
  <span class="text-text-secondary hover:text-text-secondary-hover transition-colors text-base font-medium">{{
    label()
  }}</span>
</a>
